import React from "react";

export default function Certification(){
    return(
        <div className="container" id="mainContentList">
        <h1>Under Developement</h1>
        </div>
    );
};